import React, { useEffect, useState } from "react";
import MainLayout from "../components/MainLayout";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import { BindAPI, BindPostAPI } from "../services/APIConnection";
import ReportGridPage from "../components/ReportGridPage";
import MultiSelect from "../ReusableComponents/MultiSelect";
import * as XLSX from "sheetjs-style";
import { useUserCapability } from "../components/ConstantReducerProvider";
import { checkInReportHeaders } from "../components/HeaderAttribute";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
const CheckInReport = () => {
  const { userProfileState } = useUserCapability();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const mstClientId =
    sessionStorage.getItem("MstClientId") &&
    sessionStorage.getItem("MstClientId") !== "null"
      ? Number(sessionStorage.getItem("MstClientId"))
      : 0;
  const [enquiryReportFields, setEnquiryReportFields] = useState({
    enquiryType: "",
    enquiryStatus: "",
    sourceType: "",
  });
  const [enquiryReportFieldsError, setEnquiryReportFieldsError] = useState({
    enquiryTypeError: "",
    enquiryStatusError: "",
    sourceTypeError: "",
  });
  const [bindCheckInReports, setBindCheckInReports] = useState([]);
  const [showTable, setShowTable] = useState(false);

  const [bindEnquiryType, setBindEnquiryType] = useState([]);
  const [bindEnquiryStatus, setBindEnquiryStatus] = useState([]);
  const [bindSourceType, setBindSourceType] = useState([]);

  const GoButton = async () => {
    const enquiryTypeValidate = enquiryReportFields.enquiryType
      ? ""
      : "Select Type";
    const enquiryStatusValidate = enquiryReportFields.enquiryStatus
      ? ""
      : "Select Status";

    const sourceTypeValidate = enquiryReportFields.sourceType
      ? ""
      : "Select Source Type";

    setEnquiryReportFieldsError({
      ...enquiryReportFieldsError,
      enquiryTypeError: enquiryTypeValidate,
      enquiryStatusError: enquiryStatusValidate,
      sourceTypeError: sourceTypeValidate,
    });

    let enquiryTypeArray = Array.from(
      { length: enquiryReportFields.enquiryType.length },
      (v, i) => enquiryReportFields.enquiryType[i],
    );
    let enquiryTypeResult = enquiryTypeArray.join(",");

    let enquiryStatusArray = Array.from(
      { length: enquiryReportFields.enquiryStatus.length },
      (v, i) => enquiryReportFields.enquiryStatus[i],
    );
    let enquiryStatusResult = enquiryStatusArray.join(",");

    let sourceTypeArray = Array.from(
      { length: enquiryReportFields.sourceType.length },
      (v, i) => enquiryReportFields.sourceType[i],
    );
    let sourceTypeResult = sourceTypeArray.join(",");

    if (!enquiryTypeValidate && !enquiryStatusValidate && !sourceTypeValidate) {
      const ReportData = {
        mstClientId: mstClientId,
        type: enquiryTypeResult,
        status: enquiryStatusResult,
        sourceType: sourceTypeResult,
        fromDate: fromDate,
        toDate: toDate,
      };
      const response = await BindPostAPI(
        ReportData,
        "ReportCheckInAPI/ReportCheckIn",
      );
      if (response.data.Table.length != undefined) {
        console.log("response", response.data.Table);
        setBindCheckInReports(response.data.Table);
        setShowTable(true);
      } else {
        setBindCheckInReports([]);
      }
    } else {
    }
  };

  const handleExport = () => {
    exportData(
      checkInReportHeaders.map((column) => column.title),
      bindCheckInReports,
    );
  };

  const exportData = async (columns, rows) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Check In Report");

  // ✅ Title Row
  worksheet.mergeCells(1, 1, 1, columns.length);
  const titleCell = worksheet.getCell("A1");
  titleCell.value = "Check In Report";
  titleCell.font = { bold: true, size: 16 };
  titleCell.alignment = { horizontal: "left" };

  // ✅ Header Row
  const headerRow = worksheet.addRow(columns);

  headerRow.eachCell((cell) => {
  cell.border = {
    top: { style: "thin" },
    bottom: { style: "thin" },
    left: { style: "thin" },
    right: { style: "thin" },
  };
});

  headerRow.eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF000000" },
    };
    cell.alignment = { horizontal: "left" };
  });

  // ✅ Set Column Widths
//   worksheet.columns = columns.map(() => ({ width: 30 }));

worksheet.columns = [
  { width: 8 },   // S.No
  { width: 15 },  // EnquiryNo
  { width: 18 },  // EnquiryDate
  { width: 15 },  // BookingNo
  { width: 18 },  // BookingDate
  { width: 15 },  // EnquiryType
  { width: 15 },  // BookingFrom
  { width: 15 },  // BookingTo
  { width: 15 },  // EnquiryType (duplicate)
  { width: 10 },  // NoOfDays
  { width: 25 },  // EnquiryPersonName
  { width: 18 },  // MobileNumber
  { width: 20 },  // CountryName
  { width: 20 },  // State
  { width: 20 },  // City
  { width: 30 },  // Address
  { width: 25 },  // BookingPersonName
  { width: 18 },  // BookingPersonMobileNumber
  { width: 20 },  // BookingPersonCountry
  { width: 20 },  // BookingPersonState
  { width: 20 },  // BookingPersonCity
  { width: 30 },  // BookingPersonAddress
  { width: 20 },  // ReferralSource
  { width: 20 },  // Source
  { width: 20 },  // IdProof
  { width: 20 },  // IdNumber
  { width: 20 },  // RoomTypes
  { width: 25 },  // RoomNames
  { width: 15 },  // BookingBasicTariff
  { width: 15 },  // BookingSpecialTariff
  { width: 15 },  // BookingNoOfRequiredRooms
  { width: 15 },  // BookingNoOfAdults
  { width: 15 },  // BookingNoOfChildren
  { width: 18 },  // BookingAmount
  { width: 18 },  // BookingReceivedAmount
  { width: 18 },  // BookingBalanceAmount
  { width: 20 },  // BookingPaymentType
  { width: 25 },  // BookingPaymentReferenceNumber
  { width: 18 },  // BookingStatus
  { width: 20 },  // CheckInDate
  { width: 25 },  // GuestName
  { width: 12 },  // Gender
  { width: 8 },   // Age
  { width: 18 },  // Relationship
  { width: 20 },  // IdProof
  { width: 20 },  // IDProofNumber
  { width: 15 },  // 🔥 Photo column
  { width: 15 },  // Additional Adults
  { width: 15 },  // Additional Children
  { width: 18 },  // Received Amount
  { width: 18 },  // Balance Amount
  { width: 18 },  // Payment Type
  { width: 25 },  // Payment Ref No
];

  // ✅ Add Data Rows
  for (let i = 0; i < rows.length; i++) {
    const rowData = rows[i];

    const rowValues = [
      i + 1,
      rowData.EnquiryNo,
      rowData.EnquiryDate,
      rowData.BookingNo,
      rowData.BookingDate,
      rowData.EnquiryType,
      rowData.BookingFrom,
      rowData.BookingTo,
      rowData.EnquiryType,
      rowData.NoOfDays,
      rowData.EnquiryPersonName,
      rowData.MobileNumber,
      rowData.CountryName,
      rowData.State,
      rowData.City,
      rowData.Address,
      rowData.BookingPersonName,
      rowData.BookingPersonMobileNumber,
      rowData.BookingPersonCountry,
      rowData.BookingPersonState,
      rowData.BookingPersonCity,
      rowData.BookingPersonAddress,
      rowData.ReferralSource,
      rowData.Source,
      rowData.IdProof,
      rowData.IdNumber,
      rowData.RoomTypes,
      rowData.RoomNames,
      rowData.BookingBasicTariff,
      rowData.BookingSpecialTariff,
      rowData.BookingNoOfRequiredRooms,
      rowData.BookingNoOfAdults,
      rowData.BookingNoOfChildren,
      rowData.BookingAmount,
      rowData.BookingReceivedAmount,
      rowData.BookingBalanceAmount,
      rowData.BookingPaymentType,
      rowData.BookingPaymentReferenceNumber,
      rowData.BookingStatus,
      rowData.CheckInDate,
      rowData.GuestName,
      rowData.Gender,
      rowData.Age,
      rowData.Relationship,
      rowData.IdProof,
      rowData.IDProofNumber,
      "", // 🔥 Photo placeholder
      rowData.CheckInAdditionalAdults,
      rowData.CheckInAdditionalChildren,
      rowData.CheckInReceivedAmount,
      rowData.CheckInBalanceAmount,
      rowData.CheckInPaymentType,
      rowData.CheckInPaymentReferenceNumber,
    ];

    // const row = worksheet.addRow(rowValues);
    const filledRowValues = columns.map((_, colIndex) => {
  return rowValues[colIndex] !== undefined && rowValues[colIndex] !== null
    ? rowValues[colIndex]
    : ""; // 🔥 force empty cell
});

const row = worksheet.addRow(filledRowValues);

    // ✅ Alternate row color
    if (i % 2 === 1) {
      row.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFF0F0F0" },
        };
      });
    }
// 🔥 Wrap text for Address columns
row.getCell(16).alignment = {
  wrapText: true,
  vertical: "top",
};

row.getCell(22).alignment = {
  wrapText: true,
  vertical: "top",
};
const addressLength = (rowData.Address || "").length;
const bookingAddressLength = (rowData.BookingPersonAddress || "").length;

if (addressLength > 40 || bookingAddressLength > 40) {
  row.height = 40;
}
    // // ✅ Borders
    // row.eachCell((cell) => {
    //   cell.border = {
    //     top: { style: "thin" },
    //     bottom: { style: "thin" },
    //     left: { style: "thin" },
    //     right: { style: "thin" },
    //   };
    // });

    for (let col = 1; col <= columns.length; col++) {
  const cell = row.getCell(col);

  cell.border = {
    top: { style: "thin" },
    bottom: { style: "thin" },
    left: { style: "thin" },
    right: { style: "thin" },
  };

  // also align
//   cell.alignment = { horizontal: "left" };
cell.alignment = {
  ...cell.alignment,
  horizontal: "left",
  vertical: "top",
};
}

    // 🔥 IMAGE INSERTION (MAIN PART)
    if (rowData.Photo && rowData.Photo.trim() !== "") {
      try {
        const response = await fetch(rowData.Photo);
        const blob = await response.blob();
        const buffer = await blob.arrayBuffer();

        let extension = "png";
        const contentType = response.headers.get("content-type");

        if (contentType?.includes("jpeg")) extension = "jpeg";
        else if (contentType?.includes("png")) extension = "png";
        else if (contentType?.includes("gif")) extension = "gif";

        const imageId = workbook.addImage({
          buffer: buffer,
          extension: extension,
        });

        const photoColIndex = 46; // 🔥 Photo column index (0-based)

        worksheet.addImage(imageId, {
          tl: { col: photoColIndex, row: row.number - 1 },
          ext: { width: 80, height: 80 },
        });

        worksheet.getRow(row.number).height = 60;
      } catch (err) {
        console.log("Image load failed:", rowData.Photo);
      }
    }
  }

  // ✅ Export File
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), "Check In Report.xlsx");
};
//   const exportData = (columns, rows) => {
//     const titleRow = [
//       {
//         v: "Enquiry Report",
//         s: {
//           font: { bold: true, sz: 16 },
//           alignment: { horizontal: "left" },
//         },
//       },
//     ];

//     const spacingRow = [{ v: "" }];

//     const headerRow = columns.map((column) => ({
//       v: column,
//       s: {
//         fill: { fgColor: { rgb: "000000" } },
//         font: { bold: true, color: { rgb: "FFFFFF" } },
//         alignment: { horizontal: "left" },
//       },
//     }));

//     const dataRows = rows.map((rowData, index) => {
//       const isAlternateRow = index % 2 === 1;
//       const baseStyle = isAlternateRow
//         ? { fill: { fgColor: { rgb: "F0F0F0" } } }
//         : {};
// return [
//         {
//           v: index + 1,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.EnquiryNo,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.EnquiryDate,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.BookingNo,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.BookingDate,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.EnquiryType,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.BookingFrom,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.BookingTo,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.EnquiryType,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.NoOfDays,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.EnquiryPersonName,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.MobileNumber,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },

//         {
//           v: rowData.CountryName,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },

//         {
//           v: rowData.State,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.City,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.Address,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.BookingPersonName,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.BookingPersonMobileNumber,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },

//         {
//           v: rowData.BookingPersonCountry,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.BookingPersonState,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.BookingPersonCity,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.BookingPersonAddress,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.ReferralSource,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.Source,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.IdProof,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.IdNumber,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.RoomTypes,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.RoomNames,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.BookingBasicTariff,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.BookingSpecialTariff,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.BookingNoOfRequiredRooms,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.BookingNoOfAdults,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.BookingNoOfChildren,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.BookingAmount,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.BookingReceivedAmount,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.BookingBalanceAmount,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.BookingPaymentType,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.BookingPaymentReferenceNumber,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.BookingStatus,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },

//         {
//           v: rowData.CheckInDate,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.GuestName,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.Gender,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.Age,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.Relationship,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.IdProof,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.IDProofNumber,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//   v: rowData.Photo && rowData.Photo.trim() !== ""
//     ? `=IMAGE("${encodeURI(rowData.Photo)}")`
//     : "",
//   s: { ...baseStyle, alignment: { horizontal: "left" } },
// },
//         {
//           v: rowData.CheckInAdditionalAdults,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.CheckInAdditionalChildren,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.CheckInReceivedAmount,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.CheckInBalanceAmount,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//         {
//           v: rowData.CheckInPaymentType,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
        
//         {
//           v: rowData.CheckInPaymentReferenceNumber,
//           s: { ...baseStyle, alignment: { horizontal: "left" } },
//         },
//       ];
//     //   return [
//     //     {
//     //       v: index + 1,
//     //       s: { ...baseStyle, alignment: { horizontal: "left" } },
//     //     },
//     //     {
//     //       v: rowData.BookingNo,
//     //       s: { ...baseStyle, alignment: { horizontal: "left" } },
//     //     },
//     //     {
//     //       v: rowData.BookingDate,
//     //       s: { ...baseStyle, alignment: { horizontal: "left" } },
//     //     },
//     //     {
//     //       v: rowData.CheckInDate,
//     //       s: { ...baseStyle, alignment: { horizontal: "left" } },
//     //     },
//     //     {
//     //       v: rowData.CheckOutDate,
//     //       s: { ...baseStyle, alignment: { horizontal: "left" } },
//     //     },
//     //     {
//     //       v: rowData.EnquiryType,
//     //       s: { ...baseStyle, alignment: { horizontal: "left" } },
//     //     },
//     //     {
//     //       v: rowData.ReferralSource,
//     //       s: { ...baseStyle, alignment: { horizontal: "left" } },
//     //     },
//     //     {
//     //       v: rowData.GuestName,
//     //       s: { ...baseStyle, alignment: { horizontal: "left" } },
//     //     },
//     //     {
//     //       v: rowData.MobileNumber,
//     //       s: { ...baseStyle, alignment: { horizontal: "left" } },
//     //     },

//     //     {
//     //       v: rowData.TotalAmount,
//     //       s: { ...baseStyle, alignment: { horizontal: "left" } },
//     //     },

//     //     {
//     //       v: rowData.NoOfRequiredBooked,
//     //       s: { ...baseStyle, alignment: { horizontal: "left" } },
//     //     },
//     //     {
//     //       v: rowData.NoOfDays,
//     //       s: { ...baseStyle, alignment: { horizontal: "left" } },
//     //     },
//     //     {
//     //       v: rowData.RoomTypes,
//     //       s: { ...baseStyle, alignment: { horizontal: "left" } },
//     //     },
//     //     {
//     //       v: rowData.RoomNames,
//     //       s: { ...baseStyle, alignment: { horizontal: "left" } },
//     //     },
//     //     {
//     //       v: rowData.LostReason,
//     //       s: { ...baseStyle, alignment: { horizontal: "left" } },
//     //     },
//     //   ];
//     });

//     const wsData = [titleRow, spacingRow, headerRow, ...dataRows];
//     const ws = XLSX.utils.aoa_to_sheet(wsData);

//     ws["!cols"] = [
//       { width: 8 },
//       { width: 30 },
//       { width: 30 },
//       { width: 30 },
//       { width: 30 },
//       { width: 30 },
//       { width: 30 }, // dynamic width with cap
//       { width: 30 },
//       { width: 30 },
//       { width: 30 },
//       { width: 30 },
//       { width: 30 },
//       { width: 30 },
//       { width: 30 },
//       { width: 30 },
//       { width: 30 },
//       { width: 30 },
//       { width: 30 },
//       { width: 30 },
//       { width: 30 },
//       { width: 30 },
//       { width: 30 },
//       { width: 30 },
//       { width: 30 },
//       { width: 30 },
//         { width: 30 },
//     ];

//     // Set row heights
//     ws["!rows"] = [
//       { hpt: 30 },
//       { hpt: 15 },
//       { hpt: 15 },
//       { hpt: 15 },
//       { hpt: 15 },
//       ...Array(rows.length).fill({ hpt: 15 }),
//     ];

//     // Apply borders
//     const applyStyles = (ws) => {
//       const range = XLSX.utils.decode_range(ws["!ref"]);
//       for (let R = range.s.r; R <= range.e.r; R++) {
//         for (let C = range.s.c; C <= range.e.c; C++) {
//           const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
//           if (!ws[cellRef]) continue;

//           ws[cellRef].s = {
//             ...ws[cellRef].s,
//             border: {
//               top: { style: "thin", color: { rgb: "000000" } },
//               bottom: { style: "thin", color: { rgb: "000000" } },
//               left: { style: "thin", color: { rgb: "000000" } },
//               right: { style: "thin", color: { rgb: "000000" } },
//             },
//           };
//         }
//       }
//     };

//     applyStyles(ws);

//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
//     XLSX.writeFile(wb, "Check In Report.xlsx");
//   };

  const downloadPDF = () => {};

  useEffect(() => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const automaticFromDate = `${currentYear}-01-01`;
    setFromDate(automaticFromDate);

    const formattedToDate = today.toISOString().split("T")[0];
    setToDate(formattedToDate);
  }, []);

  const enquiryReportFieldsChange = (value, name) => {
    setEnquiryReportFields({
      ...enquiryReportFields,
      [name]: value,
    });
  };
  useEffect(() => {
    BindGetEnquiryValues();
  }, []);

  const BindGetEnquiryValues = async () => {
    const data = {
      mstClientId: mstClientId,
    };
    const response = await BindPostAPI(data, "Enquiry/BindGetEnquiryValues");
    console.log("enquirydropdown:", response);
    if (response && response.data) {
      const enquiryTypeId = response.data.Table1.map((item) => ({
        value: item.MstEnquiryTypeId,
        label: item.EnquiryType,
      }));

      setBindEnquiryType(enquiryTypeId);

      const referralsourceid = response.data.Table6.map((item) => ({
        value: item.MstReferralSourceId,
        label: item.ReferralSource,
      }));
      setBindSourceType(referralsourceid);

      // const enquiryStatus = response.data.Table11.map((item) => ({
      //     value: item.MstEnquiryStatusId,
      //     label: item.EnquiryStatus,
      // }));
      const allowedStatuses = ["check in", "check out"];
      const enquiryStatus = response.data.Table11.filter((item) =>
        allowedStatuses.includes(item.EnquiryStatus.trim().toLowerCase()),
      ).map((item) => ({
        value: item.MstEnquiryStatusId,
        label: item.EnquiryStatus.trim(),
      }));
      setBindEnquiryStatus(enquiryStatus);
    }
  };

  return (
    <MainLayout pageName="4">
      <div>
        <div class="relative m-3 bg-white rounded-lg ">
          <div class="mt-3 py-4">
            <div className={mainTable.headerTitle}>
              <div className="my-2 mx-12 lg:mx-0">{`CheckIn Report`}</div>
            </div>
            <div class="mt-3">
              <div className={mainTable.grid3}>
                <div>
                  <MultiSelect
                    classStar="text-red-500"
                    label="Type"
                    filteredOptions={bindEnquiryType}
                    classFilterLabel="p-1 flex gap-1"
                    class="custom-class"
                    placeholder={
                      enquiryReportFields.enquiryType?.length > 0
                        ? "More Selected"
                        : "Select..."
                    }
                    name="enquiryType"
                    selectedOptions={enquiryReportFields.enquiryType}
                    classDiv="relative w-full inline-block"
                    onChange={(e) => {
                      setShowTable(false);
                      enquiryReportFieldsChange(e, "enquiryType");
                    }}
                    classLabel={mainTable.labelNoWrap}
                  />
                  {enquiryReportFieldsError.enquiryTypeError && (
                    <span className="text-red-500">
                      {enquiryReportFieldsError.enquiryTypeError}
                    </span>
                  )}
                </div>
                <div>
                  <MultiSelect
                    classStar="text-red-500"
                    label="Status"
                    filteredOptions={bindEnquiryStatus}
                    classFilterLabel="p-1 flex gap-1"
                    class="custom-class"
                    placeholder={
                      enquiryReportFields.enquiryStatus?.length > 0
                        ? "More Selected"
                        : "Select..."
                    }
                    name="enquiryStatus"
                    selectedOptions={enquiryReportFields.enquiryStatus}
                    classDiv="relative w-full inline-block"
                    onChange={(e) => {
                      setShowTable(false);
                      enquiryReportFieldsChange(e, "enquiryStatus");
                    }}
                    classLabel={mainTable.labelNoWrap}
                  />
                  {enquiryReportFieldsError.enquiryStatusError && (
                    <span className="text-red-500">
                      {enquiryReportFieldsError.enquiryStatusError}
                    </span>
                  )}
                </div>
                <div>
                  <MultiSelect
                    classStar="text-red-500"
                    label="Source Type"
                    filteredOptions={bindSourceType}
                    classFilterLabel="p-1 flex gap-1"
                    class="custom-class"
                    placeholder={
                      enquiryReportFields.sourceType?.length > 0
                        ? "More Selected"
                        : "Select..."
                    }
                    name="sourceType"
                    selectedOptions={enquiryReportFields.sourceType}
                    classDiv="relative w-full inline-block"
                    onChange={(e) => {
                      setShowTable(false);
                      enquiryReportFieldsChange(e, "sourceType");
                    }}
                    classLabel={mainTable.labelNoWrap}
                  />
                  {enquiryReportFieldsError.sourceTypeError && (
                    <span className="text-red-500">
                      {enquiryReportFieldsError.sourceTypeError}
                    </span>
                  )}
                </div>
              </div>
              <div class={mainTable.grid3}>
                <InputText
                  inputType="date"
                  title="From"
                  name="fromDate"
                  content={fromDate}
                  controlFunc={(e) => {
                    setShowTable(false);
                    setFromDate(e.target.value);
                  }}
                />
                <InputText
                  inputType="date"
                  title="To"
                  name="toDate"
                  content={toDate}
                  controlFunc={(e) => {
                    setShowTable(false);
                    setToDate(e.target.value);
                  }}
                />
                <div class="flex justify-start items-center mt-6">
                  <button
                    type="button"
                    onClick={() => GoButton()}
                    className={mainTable.addButton}
                  >
                    GO
                  </button>
                </div>
              </div>
            </div>
          </div>
          {showTable &&
            (bindCheckInReports.length > 0 ? (
              <div className=" ">
                <ReportGridPage
                  title=""
                  header={checkInReportHeaders}
                  records={bindCheckInReports}
                  handleExport={handleExport}
                  handlePDF={downloadPDF}
                  // xScroll=" max-md:w-fit w-full"
                />
              </div>
            ) : (
              <div className="flex items-center justify-center">
                No record found
              </div>
            ))}
        </div>
      </div>
    </MainLayout>
  );
};

export default CheckInReport;
